'use client'

import Image from "next/image"
import Link from "next/link"
import { useEffect, useState,useRef } from "react"


/**
 * Retourne la bannière de la page d'acceuil
 * @param {object} parametter - Paramètre du composant.
 * @param {string} parametter.url - Lien vers lequelle renvoie la bannière
 * @param {object} parametter.data - Donnée de la page d'acceuil 
 * @returns 
 */
export default function Banners({url,data,events,lang,local}){

    console.log(data)

    const getEventURL = (id)=>{
        const event = events.find((e)=>e.id==id)
        return event?.showAgenda =="on" ? "#" : `/${lang}/${local.staticPage.agenda}/${id}/${event?.titre[lang]}`
    }

    const containerRef = useRef(null);
    const [index,setIndex] = useState(0)

    /*useEffect(() => {
      const container = containerRef.current;
      if (!container) return;
  
      let index = 0;
      const slideCount = data.banner.length;
      const interval = setInterval(() => {
        index = (index + 1) % slideCount;
        setIndex(index)
        const slideWidth = container.offsetWidth;
        container.scrollTo({
          left: index * slideWidth,
          behavior: "smooth",
        });
      }, 5000); // toutes les 3 secondes
  
      return () => clearInterval(interval);
    }, [data.banner.length]);*/

    const ScrollTo = (newIndex) => {
    const slideCount = data.banner.length;
    const container = containerRef.current;
    const slideWidth = container.offsetWidth;
    
    const targetIndex = newIndex % slideCount;
    
    container.scrollTo({
        left: targetIndex * slideWidth,
        behavior: "smooth",
    });
    
    setIndex(targetIndex);
    };


    return(
        <div className={`relative md:p-20 p-0 aspect-video sm:aspect-auto group ${data.banner && data.banner.lenght>0 && "flex"}`}>
            <div className={`flex space-x-4 overflow-x-hidden scroll-smooth snap-x snap-mandatory`} ref={containerRef}>
                {data.banner && data.banner && data.banner.map((e, i) => (
                <Link href={e.type=="event"?getEventURL(e.event):e.url} target="_blank" key={i} className="flex-shrink-0 w-full snap-center">
                    <Image
                    width={1920}
                    height={200}
                    alt="Bannière représentant le prochain événement de l'ERM"
                    src={`/api/images/${e.image.desktop}`}
                    className="hidden sm:block w-full h-auto m-auto"
                    />
                    <Image
                    width={450}
                    height={800}
                    alt="Bannière représentant le prochain événement de l'ERM"
                    src={`/api/images/${e.image.mobile}`}
                    className="sm:hidden w-full h-auto m-auto"
                    />
                </Link>
                ))}
            </div>
            {data.banner && data.banner.length>0 && <div className="w-full flex absolute bottom-0 left-0 p-0 md:pb-20 md:px-20 transition md:opacity-0 group-hover:opacity-100">
                <div className="bg-white p-2 rounded-full my-2 space-x-4 mx-auto flex">
                    {
                        data.banner.map((e,i)=>
                            <svg key={i} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#000066" class={`size-[8px] cursor-pointer ${index !== i && 'opacity-50'}`} viewBox="0 0 16 16" onClick={()=>ScrollTo(i)}>
                                <circle cx="8" cy="8" r="8"/>
                            </svg>
                        )
                    }
                </div>
            </div>}
        </div>
    )
}